import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Collapse as RawCollapse } from 'react-collapse';
import { OuterContainer, BtnContainer } from './Collapse.styles';
import { Icon, Text } from '@oneaudi/unified-web-components';
import { SYS_SIZE_FIXED_150 } from '@oneaudi/unified-web-common';
interface CollapseProps {
  heading: string;
  children: React.ReactNode;
}

const Collapse: React.FC<CollapseProps> = ({ heading, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const { t } = useTranslation();

  const handleClick = () => {
    setIsOpen(!isOpen);
  };
  const handleWork = () => {
    setIsAnimating(true);
  };
  const handleRest = () => {
    setIsAnimating(false);
  };

  return (
    <OuterContainer>
      <BtnContainer
        onClick={handleClick}
        aria-label={`${heading} ${
          isOpen ? t(`vehicleHistory.ariaLabel.expanded`) : t(`vehicleHistory.ariaLabel.contracted`)
        }`}
      >
        <Text
          margin={[0, SYS_SIZE_FIXED_150, 0, 0]}
          variant={{
            order: '2',
            type: 'copy',
            style: 'normal',
          }}
        >
          {heading}
        </Text>
        {isOpen ? <Icon name="arrow-up" size="xs" /> : <Icon name="arrow-down" size="xs" />}
      </BtnContainer>
      {/* To prevent focus on hidden elements we only render them as needed */}
      <RawCollapse isOpened={isOpen} onWork={handleWork} onRest={handleRest}>
        <>{(isOpen || isAnimating) && children}</>
      </RawCollapse>
    </OuterContainer>
  );
};

export default Collapse;
